import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "buttons",
  style: {"margin-top":"10px"}
}
const _hoisted_2 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("清空")

import {requestTreestructdata,requestEchoTreedata,requestEchoTreesave } from '@/api/api'
import { ref,onMounted } from 'vue'
import { ElTree,ElMessage } from 'element-plus'
import type Node from 'element-plus/es/components/tree/src/model/node'
interface Tree {
  id: number
  label: string
  children?: Tree[]
}


export default /*#__PURE__*/_defineComponent({
  name: 'Ztree',
  props: {
		roleid:{
			type: String,
			default: ""
		},
		lb:{
			type: String,
			default: ""
		},
		needInt:{
			type: String,
			default: "true"
		}
},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props



const savetree =()=>{
//alert(props.roleid);
  var tj=[];
  var checked=treeRef.value!.getCheckedKeys(false);
								console.log(props.needInt);
  for(var i=0;i<checked.length;i++){
  	if(props.needInt=="true"){
  		if(parseInt(checked[i])){
  			tj.push(parseInt(checked[i]));
  		}
  	}else{
  		tj.push((checked[i]));
  	}
  }
  	requestEchoTreesave({
		lb:props.lb,
		roleid:props.roleid,
		userid:tj.join(',')
	}).then((res:any)=>{
		if(res.status === 1){
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			
				setTimeout(()=>{
					emit("cancel",1)
				},500)
		}else{
			ElMessage.error(res.msg);
		}
	})

}
const treeRef = ref<InstanceType<typeof ElTree>>()

const getCheckedNodes = () => {
  console.log(treeRef.value!.getCheckedNodes(false, false))
}
const getCheckedKeys = () => {
  console.log(treeRef.value!.getCheckedKeys(false))
}

const resetChecked = () => {
  treeRef.value!.setCheckedKeys([], false)
}

const defaultProps = {
  children: 'children',
  label: 'label',
}

const data= ref([])
const defaultChecked=ref([])
	onMounted(()=>{
		if(props.roleid != ""){
			requestTreestructdata({
				lb:props.lb
			}).then((res:any)=>{
				if(res.status === 1){
					data.value = res.datalist
					console.log(data.value);
					requestEchoTreedata({
						roleid:props.roleid,
						lb:props.lb
					}).then((res:any)=>{
						if(res.status === 1){
							defaultChecked.value=[]
							for(var i=0;i<res.datalist.length;i++){
								console.log(props.needInt);
								if(props.needInt=="true"){
									defaultChecked.value.push(parseInt(res.datalist[i].id));
								}else{
									defaultChecked.value.push((res.datalist[i].id));
								}
							}
							console.log(defaultChecked.value);
						}
					})
				}
			})
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElTree), {
      ref_key: "treeRef",
      ref: treeRef,
      data: data.value,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "id",
      "highlight-current": "",
      props: defaultProps,
      "default-checked-keys": defaultChecked.value,
      style: {"max-height":"400px","overflow":"auto"}
    }, null, 8, ["data", "default-checked-keys"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          style: {"color":"#fff"},
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (savetree())),
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: resetChecked,
          style: {"border-radius":"20px"}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})